module.exports = __webpack_public_path__ + "img/18.fe95160a.jpg";